module.exports = __webpack_public_path__ + "static/media/frei.38c765ba.svg";